/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  authenticated: false,
  isBroker: false,
  isInternal: false,
  brokerCustomersData: [],
  permissions: [],
  name: null,
  phone: null,
  bdUploadedProjects: null,
  fbid: null,
  googleProfileImage: null,
  isVerified: false,
  countryCode: '',
  favHomeProject: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js